<form>
  <input
    name="inputDiameter"
    [id]="inputId"
    class="filerable-input-input"
    #autocompleteInput="matAutocompleteTrigger"
    autocomplete="off"         

    [disabled]="inputDisabled"
    [matAutocomplete]="auto"
    [disabled]="inputDisabled"

    [(ngModel)]="inputModel"
    (ngModelChange)="inputModelChange.emit(inputModel)"        
    (focus)="onInputFocus($event)"
    (focusout)="mOnFocusOut.emit($event)"
    (keyup)="onInputKeyUp($event)"
    (keyup.enter)="autocompleteInput.closePanel()"
    (keypress)="onInputKeyPress($event)"
    (change)="onInputChange($event)">
  <mat-autocomplete #auto>
    <mat-option *ngFor="let item of filteredAutoCompletedValue | async" [value]="item">{{item}}</mat-option>
  </mat-autocomplete>
</form>     
<!--     
  (change)="checkDiam(element)"
    
-->